'use client';

import { theme } from '@/app/common/providers/theme-provider/theme';
import { Container, Stack, styled, useMediaQuery } from '@mui/material';
import Image from 'next/image';
import { ReactNode } from 'react';
import MomentsText from './components/moments-text/moments-text';
import { StyledButton } from '../ui';
import { Constellation } from './components/constellation/constellation';
import Link from 'next/link';
import { config } from '@/config/environment';

const OuterStack = styled(Stack)`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  gap: 40px;
  ${({ theme }) => theme.breakpoints.down('sm')} {
    flex-direction: column;
    justify-content: center;
  }
`;

const InnerStack = styled(Stack)`
  width: 50%;
  justify-content: center;
  gap: 16px;
  ${({ theme }) => theme.breakpoints.down('sm')} {
    width: 100%;
    padding: 0px 0px;
  }
`;
const StyledImage = styled(Image)`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

export const momentsExplainerContent = {
  title: 'Moments matter',
  text: (
    <>
      <p>
        Curiko was built on the premise that a flourishing life is made up of big and little moments
        of connection.
      </p>
      <p>
        Experiences were vehicles for people to connect to themselves, to others, and to the wider
        world. Our evaluation showed how moments are at the heart of wellbeing and quality of life.
      </p>
    </>
  ),
  image: '/moments/images/moments-diagram.png',
};

interface MomentsProps {
  title?: ReactNode;
  text?: ReactNode;
  image?: string;
}

export function Moments({
  title = momentsExplainerContent.title,
  text = momentsExplainerContent.text,
  image = momentsExplainerContent.image,
}: MomentsProps) {
  const archiveMode = config.platformMode === 'archive';
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <>
      {/* <MomentsDiv> */}
      {/* <StyledContainer> */}
      <Container sx={{ mx: 'auto' }}>
        <OuterStack>
          <InnerStack>
            <Constellation />
          </InnerStack>
          <InnerStack>
            <MomentsText
              title={archiveMode ? momentsExplainerContent.title : title}
              text={archiveMode ? momentsExplainerContent.text : text}
            />
            <Link href="/galaxy-of-moments">
              <StyledButton>Learn more</StyledButton>
            </Link>
          </InnerStack>
        </OuterStack>
      </Container>
      {/* </StyledContainer> */}
      {/* </MomentsDiv> */}
    </>
  );
}
